// SolicitudesEntregas.js
import React, { useState, useEffect } from 'react';
import './SolicitudesEntregas.css';

const SolicitudesEntregas = () => {
  const [solicitudes, setSolicitudes] = useState([]);
  const [solicitudesFiltradas, setSolicitudesFiltradas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtros, setFiltros] = useState({
    estado: 'todos',
    area: 'todos',
    usuario: 'todos',
    montoMin: '',
    montoMax: ''
  });

  // 17 ejemplos de solicitudes
  const datosEjemplo = [
    {
      "OV": "231546",
      "CardCode": "CLIE321654",
      "CardName": "Empresa ABC SA de CV",
      "Monto": "215.20",
      "Fecha": "2025-01-15T10:15:32.218",
      "Autorizaciones": [
        {"USUARIO": "Junior", "Fecha": "2025-01-15T10:25:12.587", "AREA": "OPERACIONES"},
        {"USUARIO": "Ana", "Fecha": "2025-01-15T10:30:12.587", "AREA": "VENTAS"}
      ]
    },
    {
      "OV": "231547",
      "CardCode": "CLIE321655",
      "CardName": "Distribuidora XYZ",
      "Monto": "150.00",
      "Fecha": "2025-01-15T16:30:32.218",
      "Autorizaciones": [
        {"USUARIO": "Carlos", "Fecha": "2025-01-15T16:35:12.587", "AREA": "OPERACIONES"}
      ]
    },
    {
      "OV": "231548", 
      "CardCode": "CLIE321656",
      "CardName": "Comercializadora Norte",
      "Monto": "320.75",
      "Fecha": "2025-01-15T09:15:32.218",
      "Autorizaciones": []
    },
    {
      "OV": "231549",
      "CardCode": "CLIE321657",
      "CardName": "Importaciones del Sur",
      "Monto": "450.00",
      "Fecha": "2025-01-15T14:20:32.218",
      "Autorizaciones": [
        {"USUARIO": "Maria", "Fecha": "2025-01-15T14:25:12.587", "AREA": "VENTAS"}
      ]
    },
    {
      "OV": "231550",
      "CardCode": "CLIE321658",
      "CardName": "Exportaciones Global",
      "Monto": "1200.50",
      "Fecha": "2025-01-15T18:15:32.218",
      "Autorizaciones": [
        {"USUARIO": "Roberto", "Fecha": "2025-01-15T18:20:12.587", "AREA": "OPERACIONES"}
      ]
    },
    {
      "OV": "231551",
      "CardCode": "CLIE321659",
      "CardName": "Manufacturas Industriales",
      "Monto": "75.30",
      "Fecha": "2025-01-16T08:45:32.218",
      "Autorizaciones": []
    },
    {
      "OV": "231552",
      "CardCode": "CLIE321660",
      "CardName": "Tecnología Avanzada",
      "Monto": "890.25",
      "Fecha": "2025-01-16T11:30:32.218",
      "Autorizaciones": [
        {"USUARIO": "Laura", "Fecha": "2025-01-16T11:35:12.587", "AREA": "OPERACIONES"},
        {"USUARIO": "Pedro", "Fecha": "2025-01-16T11:40:12.587", "AREA": "VENTAS"}
      ]
    },
    {
      "OV": "231553",
      "CardCode": "CLIE321661",
      "CardName": "Soluciones Integrales",
      "Monto": "340.00",
      "Fecha": "2025-01-16T17:45:32.218",
      "Autorizaciones": [
        {"USUARIO": "Carlos", "Fecha": "2025-01-16T17:50:12.587", "AREA": "OPERACIONES"}
      ]
    },
    {
      "OV": "231554",
      "CardCode": "CLIE321662",
      "CardName": "Servicios Profesionales",
      "Monto": "210.80",
      "Fecha": "2025-01-17T09:00:32.218",
      "Autorizaciones": []
    },
    {
      "OV": "231555",
      "CardCode": "CLIE321663",
      "CardName": "Insumos Médicos",
      "Monto": "560.90",
      "Fecha": "2025-01-17T12:15:32.218",
      "Autorizaciones": [
        {"USUARIO": "Ana", "Fecha": "2025-01-17T12:20:12.587", "AREA": "VENTAS"}
      ]
    },
    {
      "OV": "231556",
      "CardCode": "CLIE321664",
      "CardName": "Materiales Construcción",
      "Monto": "780.45",
      "Fecha": "2025-01-17T16:20:32.218",
      "Autorizaciones": [
        {"USUARIO": "Junior", "Fecha": "2025-01-17T16:25:12.587", "AREA": "OPERACIONES"},
        {"USUARIO": "Maria", "Fecha": "2025-01-17T16:30:12.587", "AREA": "VENTAS"}
      ]
    },
    {
      "OV": "231557",
      "CardCode": "CLIE321665",
      "CardName": "Equipos Industriales",
      "Monto": "1500.00",
      "Fecha": "2025-01-18T10:30:32.218",
      "Autorizaciones": []
    },
    {
      "OV": "231558",
      "CardCode": "CLIE321666",
      "CardName": "Herramientas Especializadas",
      "Monto": "230.75",
      "Fecha": "2025-01-18T13:45:32.218",
      "Autorizaciones": [
        {"USUARIO": "Roberto", "Fecha": "2025-01-18T13:50:12.587", "AREA": "OPERACIONES"}
      ]
    },
    {
      "OV": "231559",
      "CardCode": "CLIE321667",
      "CardName": "Suministros Oficina",
      "Monto": "95.60",
      "Fecha": "2025-01-18T18:10:32.218",
      "Autorizaciones": [
        {"USUARIO": "Carlos", "Fecha": "2025-01-18T18:15:12.587", "AREA": "OPERACIONES"}
      ]
    },
    {
      "OV": "231560",
      "CardCode": "CLIE321668",
      "CardName": "Productos Químicos",
      "Monto": "670.30",
      "Fecha": "2025-01-19T08:20:32.218",
      "Autorizaciones": [
        {"USUARIO": "Laura", "Fecha": "2025-01-19T08:25:12.587", "AREA": "OPERACIONES"},
        {"USUARIO": "Pedro", "Fecha": "2025-01-19T08:30:12.587", "AREA": "VENTAS"}
      ]
    },
    {
      "OV": "231561",
      "CardCode": "CLIE321669",
      "CardName": "Alimentos y Bebidas",
      "Monto": "420.15",
      "Fecha": "2025-01-19T14:35:32.218",
      "Autorizaciones": []
    },
    {
      "OV": "231562",
      "CardCode": "CLIE321670",
      "CardName": "Textiles y Confecciones",
      "Monto": "310.80",
      "Fecha": "2025-01-19T17:50:32.218",
      "Autorizaciones": [
        {"USUARIO": "Ana", "Fecha": "2025-01-19T17:55:12.587", "AREA": "VENTAS"}
      ]
    }
  ];

  useEffect(() => {
    // Simular carga de datos
    setTimeout(() => {
      const solicitudesConEstado = datosEjemplo.map(solicitud => ({
        ...solicitud,
        estado: determinarEstado(solicitud.Autorizaciones, solicitud.Fecha),
        usuarioActual: "UsuarioActual" // Simula el usuario logueado
      }));
      setSolicitudes(solicitudesConEstado);
      setSolicitudesFiltradas(solicitudesConEstado);
      setLoading(false);
    }, 1000);
  }, []);

  // Función para determinar el estado de autorización
  const determinarEstado = (autorizaciones, fechaSolicitud) => {
    // Verificar si hay algún rechazo
    const tieneRechazo = autorizaciones.some(auth => auth.AREA === 'RECHAZO');
    if (tieneRechazo) {
      return 'RECHAZADA';
    }

    const fecha = new Date(fechaSolicitud);
    const hora = fecha.getHours();
    const esDespuesDe5pm = hora >= 17;
    
    const areasAutorizadas = autorizaciones.map(auth => auth.AREA);
    const tieneOperaciones = areasAutorizadas.includes('OPERACIONES');
    const tieneVentas = areasAutorizadas.includes('VENTAS');
    
    if (esDespuesDe5pm) {
      return tieneOperaciones ? 'AUTORIZACION PARCIAL' : 'PENDIENTE';
    } else {
      if (tieneOperaciones && tieneVentas) {
        return 'APROBADA PARA ENTREGAR';
      } else if (tieneOperaciones || tieneVentas) {
        return 'AUTORIZACION PARCIAL';
      } else {
        return 'PENDIENTE';
      }
    }
  };

  // Función para autorizar una solicitud
  const autorizarSolicitud = (ov, area) => {
    const fechaActual = new Date().toISOString();
    const usuarioActual = "UsuarioActual"; // En una app real, esto vendría del contexto de autenticación
    
    setSolicitudes(prev => prev.map(solicitud => {
      if (solicitud.OV === ov) {
        const nuevasAutorizaciones = [
          ...solicitud.Autorizaciones,
          {
            USUARIO: usuarioActual,
            Fecha: fechaActual,
            AREA: area
          }
        ];
        
        const nuevoEstado = determinarEstado(nuevasAutorizaciones, solicitud.Fecha);
        
        return {
          ...solicitud,
          Autorizaciones: nuevasAutorizaciones,
          estado: nuevoEstado
        };
      }
      return solicitud;
    }));
  };

  // Función para rechazar una solicitud
  const rechazarSolicitud = (ov) => {
    const fechaActual = new Date().toISOString();
    const usuarioActual = "UsuarioActual";
    
    setSolicitudes(prev => prev.map(solicitud => {
      if (solicitud.OV === ov) {
        const nuevasAutorizaciones = [
          ...solicitud.Autorizaciones,
          {
            USUARIO: usuarioActual,
            Fecha: fechaActual,
            AREA: 'RECHAZO',
            TIPO: 'RECHAZO_ENTREGA'
          }
        ];
        
        return {
          ...solicitud,
          Autorizaciones: nuevasAutorizaciones,
          estado: 'RECHAZADA'
        };
      }
      return solicitud;
    }));
  };

  // Ordenar solicitudes por estado
  const ordenarPorEstado = (solicitudes) => {
    const ordenEstados = {
      'PENDIENTE': 1,
      'AUTORIZACION PARCIAL': 2,
      'APROBADA PARA ENTREGAR': 3,
      'RECHAZADA': 4
    };
    
    return [...solicitudes].sort((a, b) => 
      ordenEstados[a.estado] - ordenEstados[b.estado]
    );
  };

  // Aplicar filtros
  useEffect(() => {
    let resultado = [...solicitudes];

    // Filtro por estado
    if (filtros.estado !== 'todos') {
      resultado = resultado.filter(s => s.estado === filtros.estado);
    }

    // Filtro por área
    if (filtros.area !== 'todos') {
      resultado = resultado.filter(s => 
        s.Autorizaciones.some(auth => auth.AREA === filtros.area)
      );
    }

    // Filtro por usuario
    if (filtros.usuario !== 'todos') {
      resultado = resultado.filter(s => 
        s.Autorizaciones.some(auth => auth.USUARIO === filtros.usuario)
      );
    }

    // Filtro por monto mínimo
    if (filtros.montoMin) {
      resultado = resultado.filter(s => parseFloat(s.Monto) >= parseFloat(filtros.montoMin));
    }

    // Filtro por monto máximo
    if (filtros.montoMax) {
      resultado = resultado.filter(s => parseFloat(s.Monto) <= parseFloat(filtros.montoMax));
    }

    setSolicitudesFiltradas(ordenarPorEstado(resultado));
  }, [filtros, solicitudes]);

  // Obtener estadísticas
  const obtenerEstadisticas = () => {
    const total = solicitudes.length;
    const porEstado = solicitudes.reduce((acc, solicitud) => {
      acc[solicitud.estado] = (acc[solicitud.estado] || 0) + 1;
      return acc;
    }, {});

    const totalFiltradas = solicitudesFiltradas.length;
    const porEstadoFiltradas = solicitudesFiltradas.reduce((acc, solicitud) => {
      acc[solicitud.estado] = (acc[solicitud.estado] || 0) + 1;
      return acc;
    }, {});

    return { total, porEstado, totalFiltradas, porEstadoFiltradas };
  };

  const estadisticas = obtenerEstadisticas();

  // Obtener opciones únicas para filtros
  const obtenerOpcionesFiltro = () => {
    const areas = [...new Set(solicitudes.flatMap(s => 
      s.Autorizaciones.map(a => a.AREA).filter(area => area !== 'RECHAZO')
    ))];
    const usuarios = [...new Set(solicitudes.flatMap(s => s.Autorizaciones.map(a => a.USUARIO)))];
    
    return { areas, usuarios };
  };

  const opcionesFiltro = obtenerOpcionesFiltro();

  const handleFiltroChange = (campo, valor) => {
    setFiltros(prev => ({
      ...prev,
      [campo]: valor
    }));
  };

  // Función para filtrar por estado al hacer clic en el resumen
  const filtrarPorEstado = (estado) => {
    setFiltros(prev => ({
      ...prev,
      estado: estado
    }));
  };

  // Función para mostrar todas las solicitudes
  const mostrarTodas = () => {
    setFiltros({
      estado: 'todos',
      area: 'todos',
      usuario: 'todos',
      montoMin: '',
      montoMax: ''
    });
  };

  const limpiarFiltros = () => {
    setFiltros({
      estado: 'todos',
      area: 'todos',
      usuario: 'todos',
      montoMin: '',
      montoMax: ''
    });
  };

  // Función para formatear fecha en español DD/MM/AAAA
  const formatearFecha = (fechaString) => {
    const fecha = new Date(fechaString);
    const dia = fecha.getDate().toString().padStart(2, '0');
    const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const anio = fecha.getFullYear();
    const horas = fecha.getHours().toString().padStart(2, '0');
    const minutos = fecha.getMinutes().toString().padStart(2, '0');
    
    return `${dia}/${mes}/${anio} ${horas}:${minutos}`;
  };

  // Verificar si una área ya autorizó
  const areaYaAutorizo = (autorizaciones, area) => {
    return autorizaciones.some(auth => auth.AREA === area);
  };

  // Obtener información del rechazo
  const obtenerInfoRechazo = (autorizaciones) => {
    const rechazo = autorizaciones.find(auth => auth.AREA === 'RECHAZO');
    return rechazo || null;
  };

  if (loading) {
    return (
      <div className="solicitudes-container">
        <div className="loading">Cargando solicitudes...</div>
      </div>
    );
  }

  return (
    <div className="solicitudes-container">
      <div className="sidebar">
        <h3>Filtros</h3>
        
        <div className="filtro-group">
          <label>Estado:</label>
          <select 
            value={filtros.estado} 
            onChange={(e) => handleFiltroChange('estado', e.target.value)}
          >
            <option value="todos">Todos los estados</option>
            <option value="PENDIENTE">Pendiente</option>
            <option value="AUTORIZACION PARCIAL">Autorización Parcial</option>
            <option value="APROBADA PARA ENTREGAR">Aprobada para Entregar</option>
            <option value="RECHAZADA">Rechazada</option>
          </select>
        </div>

        <div className="filtro-group">
          <label>Área:</label>
          <select 
            value={filtros.area} 
            onChange={(e) => handleFiltroChange('area', e.target.value)}
          >
            <option value="todos">Todas las áreas</option>
            {opcionesFiltro.areas.map(area => (
              <option key={area} value={area}>{area}</option>
            ))}
          </select>
        </div>

        <div className="filtro-group">
          <label>Usuario:</label>
          <select 
            value={filtros.usuario} 
            onChange={(e) => handleFiltroChange('usuario', e.target.value)}
          >
            <option value="todos">Todos los usuarios</option>
            {opcionesFiltro.usuarios.map(usuario => (
              <option key={usuario} value={usuario}>{usuario}</option>
            ))}
          </select>
        </div>

        <div className="filtro-group">
          <label>Monto Mínimo (Q):</label>
          <input 
            type="number" 
            value={filtros.montoMin}
            onChange={(e) => handleFiltroChange('montoMin', e.target.value)}
            placeholder="0.00"
            step="0.01"
          />
        </div>

        <div className="filtro-group">
          <label>Monto Máximo (Q):</label>
          <input 
            type="number" 
            value={filtros.montoMax}
            onChange={(e) => handleFiltroChange('montoMax', e.target.value)}
            placeholder="10000.00"
            step="0.01"
          />
        </div>

        <button className="btn-limpiar" onClick={limpiarFiltros}>
          Limpiar Filtros
        </button>

        {/* Resumen de estadísticas */}
        <div className="resumen-sidebar">
          <h4>Resumen General</h4>
          <div 
            className={`estadistica-item ${filtros.estado === 'todos' ? 'activo' : ''}`}
            onClick={mostrarTodas}
          >
            <span>Total Solicitudes:</span>
            <strong>{estadisticas.total}</strong>
          </div>
          <div 
            className={`estadistica-item pendiente ${filtros.estado === 'PENDIENTE' ? 'activo' : ''}`}
            onClick={() => filtrarPorEstado('PENDIENTE')}
          >
            <span>Pendientes:</span>
            <strong>{estadisticas.porEstado['PENDIENTE'] || 0}</strong>
          </div>
          <div 
            className={`estadistica-item parcial ${filtros.estado === 'AUTORIZACION PARCIAL' ? 'activo' : ''}`}
            onClick={() => filtrarPorEstado('AUTORIZACION PARCIAL')}
          >
            <span>Parciales:</span>
            <strong>{estadisticas.porEstado['AUTORIZACION PARCIAL'] || 0}</strong>
          </div>
          <div 
            className={`estadistica-item aprobada ${filtros.estado === 'APROBADA PARA ENTREGAR' ? 'activo' : ''}`}
            onClick={() => filtrarPorEstado('APROBADA PARA ENTREGAR')}
          >
            <span>Aprobadas:</span>
            <strong>{estadisticas.porEstado['APROBADA PARA ENTREGAR'] || 0}</strong>
          </div>
          <div 
            className={`estadistica-item rechazada ${filtros.estado === 'RECHAZADA' ? 'activo' : ''}`}
            onClick={() => filtrarPorEstado('RECHAZADA')}
          >
            <span>Rechazadas:</span>
            <strong>{estadisticas.porEstado['RECHAZADA'] || 0}</strong>
          </div>
        </div>
      </div>

      <div className="main-content">
        <h1>Solicitudes de Entrega de OV sin Pago</h1>
        
        {/* Resumen principal */}
        <div className="resumen-principal">
          <div className="resumen-cards">
            <div 
              className={`resumen-card total ${filtros.estado === 'todos' ? 'activo' : ''}`}
              onClick={mostrarTodas}
            >
              <h3>Total</h3>
              <span className="numero">{estadisticas.totalFiltradas}</span>
              <span className="label">solicitudes filtradas</span>
            </div>
            <div 
              className={`resumen-card pendiente ${filtros.estado === 'PENDIENTE' ? 'activo' : ''}`}
              onClick={() => filtrarPorEstado('PENDIENTE')}
            >
              <h3>Pendientes</h3>
              <span className="numero">{estadisticas.porEstadoFiltradas['PENDIENTE'] || 0}</span>
              <span className="label">por autorizar</span>
            </div>
            <div 
              className={`resumen-card parcial ${filtros.estado === 'AUTORIZACION PARCIAL' ? 'activo' : ''}`}
              onClick={() => filtrarPorEstado('AUTORIZACION PARCIAL')}
            >
              <h3>Parciales</h3>
              <span className="numero">{estadisticas.porEstadoFiltradas['AUTORIZACION PARCIAL'] || 0}</span>
              <span className="label">autorización parcial</span>
            </div>
            <div 
              className={`resumen-card aprobada ${filtros.estado === 'APROBADA PARA ENTREGAR' ? 'activo' : ''}`}
              onClick={() => filtrarPorEstado('APROBADA PARA ENTREGAR')}
            >
              <h3>Aprobadas</h3>
              <span className="numero">{estadisticas.porEstadoFiltradas['APROBADA PARA ENTREGAR'] || 0}</span>
              <span className="label">listas para entregar</span>
            </div>
            <div 
              className={`resumen-card rechazada ${filtros.estado === 'RECHAZADA' ? 'activo' : ''}`}
              onClick={() => filtrarPorEstado('RECHAZADA')}
            >
              <h3>Rechazadas</h3>
              <span className="numero">{estadisticas.porEstadoFiltradas['RECHAZADA'] || 0}</span>
              <span className="label">solicitudes rechazadas</span>
            </div>
          </div>
        </div>

        {/* Indicador de filtro activo */}
        {filtros.estado !== 'todos' && (
          <div className="filtro-activo">
            <span>Filtro activo: <strong>{filtros.estado}</strong></span>
            <button onClick={mostrarTodas}>Mostrar todas</button>
          </div>
        )}

        <div className="solicitudes-grid">
          {solicitudesFiltradas.length > 0 ? (
            solicitudesFiltradas.map((solicitud, index) => {
              const infoRechazo = obtenerInfoRechazo(solicitud.Autorizaciones);
              
              return (
                <div key={index} className={`solicitud-card ${solicitud.estado.toLowerCase().replace(' ', '-')}`}>
                  <div className="solicitud-header">
                    <h3>OV: {solicitud.OV}</h3>
                    <span className={`estado-badge ${solicitud.estado.toLowerCase().replace(' ', '-')}`}>
                      {solicitud.estado}
                    </span>
                  </div>
                  
                  <div className="solicitud-info">
                    <p><strong>Cliente:</strong> {solicitud.CardName}</p>
                    <p><strong>Código:</strong> {solicitud.CardCode}</p>
                    <p><strong>Monto:</strong> Q{solicitud.Monto}</p>
                    <p><strong>Fecha Solicitud:</strong> {formatearFecha(solicitud.Fecha)}</p>
                  </div>
                  
                  <div className="autorizaciones">
                    <h4>Autorizaciones:</h4>
                    {solicitud.Autorizaciones.length > 0 ? (
                      <ul>
                        {solicitud.Autorizaciones.map((auth, authIndex) => (
                          <li 
                            key={authIndex} 
                            className={auth.AREA === 'RECHAZO' ? 'rechazo-item' : ''}
                          >
                            {auth.AREA === 'RECHAZO' ? (
                              <>
                                <strong>❌ RECHAZO</strong> - {auth.USUARIO} 
                                <br />
                                <small>{formatearFecha(auth.Fecha)}</small>
                                <div className="motivo-rechazo">
                                  <em>Entrega rechazada</em>
                                </div>
                              </>
                            ) : (
                              <>
                                <strong>{auth.AREA}</strong> - {auth.USUARIO} 
                                <br />
                                <small>{formatearFecha(auth.Fecha)}</small>
                              </>
                            )}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p className="sin-autorizaciones">No hay autorizaciones registradas</p>
                    )}
                  </div>

                  {/* Botones de acción para Pendientes y Parciales */}
                  {(solicitud.estado === 'PENDIENTE' || solicitud.estado === 'AUTORIZACION PARCIAL') && (
                    <div className="acciones-solicitud">
                      <div className="botones-autorizacion">
                        <h4>Autorizar como:</h4>
                        <div className="grupo-botones">
                          {!areaYaAutorizo(solicitud.Autorizaciones, 'OPERACIONES') && (
                            <button 
                              className="btn-autorizar operaciones"
                              onClick={() => autorizarSolicitud(solicitud.OV, 'OPERACIONES')}
                            >
                              ✅ Operaciones
                            </button>
                          )}
                          {!areaYaAutorizo(solicitud.Autorizaciones, 'VENTAS') && (
                            <button 
                              className="btn-autorizar ventas"
                              onClick={() => autorizarSolicitud(solicitud.OV, 'VENTAS')}
                            >
                              ✅ Ventas
                            </button>
                          )}
                        </div>
                      </div>
                      <button 
                        className="btn-rechazar"
                        onClick={() => rechazarSolicitud(solicitud.OV)}
                      >
                        ❌ Rechazar Entrega
                      </button>
                    </div>
                  )}

                  {/* Información de rechazo */}
                  {solicitud.estado === 'RECHAZADA' && infoRechazo && (
                    <div className="solicitud-rechazada">
                      <p>
                        <strong>❌ Esta solicitud ha sido rechazada</strong>
                        <br />
                        <small>Por: {infoRechazo.USUARIO} el {formatearFecha(infoRechazo.Fecha)}</small>
                      </p>
                    </div>
                  )}
                </div>
              );
            })
          ) : (
            <div className="no-resultados">
              <p>No se encontraron solicitudes con los filtros aplicados.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SolicitudesEntregas;